import { UserType } from './user-type.model';
import { Card } from '../card/card.model';
import { Role } from '../role.model';
import { Permission } from '../permissions/permission.model';

export enum UserTypeId {
  Adria = 1,
  Client = 2,
  Guest = 3,
  GuestWithoutRoom = 5,
}

export class User {
    userId: number;
    id3dParty: string;
    typeId: number;
    email: string;
    firstName: string;
    lastName: string;
    password: string;
    refreshToken: string;
    customData: any;
    cards: Card[];
    type: UserType;
    fullName: string;
    cardLaters: Card[];
    token: string;
    permissions: any[];
    roles: Role[];
    activeUser: boolean;
    pin: string;
    licencePlate: string;

    constructor() {}


    public static isAdria(user: User) {
      return user.userId === 1
    }

    public static hasAnyOfRequiredPermissions(user: User, permissionCodes: string[]){
      let userHasPermission = false;
      userHasPermission = user?.roles?.some((role: Role)=> {
          return role?.permissions?.some((rolePerm: Permission)=> {
            return permissionCodes.includes(rolePerm.permissionCode)
          })
        })
      if (!userHasPermission) {
          userHasPermission = user?.permissions?.some((perm: Permission)=> {
              return permissionCodes.includes(perm.permissionCode)
          })
        }
      return userHasPermission
    }

    havePermission(permissionCode: string) {
        let userPermission = false;
        userPermission = this.roles?.some(role => role.permissions.some(permission => permission.permissionCode === permissionCode));
        if (!userPermission) {
           userPermission = this.permissions?.some(permission => permission.permissionCode === permissionCode);
        }
        return userPermission;
    }

    haveRole(roleId: number) {
        return this.roles?.some(role => role.roleId === roleId);
    }
}
